module.exports = __webpack_public_path__ + "static/media/footer-recherche-active.58324507.png";